import React from 'react';
import Step from './Step';
import StepModel from '../../../model/configurator/StepModel';
import ExpandableContainer from './ExpandableContainer';
import CrossReferencedHeatingField from '../../../model/configurator/controller/CrossReferencedHeatingField';
import Field from '../../../model/configurator/Field';
import CrossReferencedDHWField from '../../../model/configurator/CrossReferencedDHWField';
import StepHorizontalField from './StepHorizontalField';
import * as Row from '../../layout/Row';

export default class StepOptions extends Step {
    renderBody() {


        return (
            <React.Fragment>
                {this.renderGeneralInformation()}
                {/* {this.renderAdditionalModules()} */}
            </React.Fragment>
        )
    }

    renderGeneralInformation() {
        const pumpAddonVisible = [
            this.fields.heating1PumpAddon.visible,
            this.fields.heating2PumpAddon.visible,
            this.fields.heating3PumpAddon.visible,
            this.fields.dhwPumpAddon.visible].some(x => x);

        return (
            <ExpandableContainer label={__('General options')} initialOpen={true}>

                {this.renderSection(this.fields.commisioning, this.fields.iqHeatCloud, this.fields.pipeInsulation, this.fields.heating1PumpAddon, this.fields.heating2PumpAddon, this.fields.heating3PumpAddon, this.fields.dhwPumpAddon, this.fields.additionalOptions) ?
                    <React.Fragment>

                        {this.renderGenericHorizontalField(this.fields.commisioning)}
                        {this.renderGenericHorizontalField(this.fields.iqHeatCloud)}
                        {this.renderGenericHorizontalField(this.fields.pipeInsulation)}
                        <div className="pump-add-on">
                            <StepHorizontalField label={__('Pump add on')} className="controller-heating-sensor"
                                                 visible={pumpAddonVisible}>
                                <Row.Container hasOuterGutter={false} className="w-100">
                                    {this.fields.heating1PumpAddon.visible && (
                                        <Row.Column3>
                                            <span
                                                className="configuration-editor-controller-heating-label heating-name-antioverflow">{this.props.model.heating1.name.value}</span>
                                            {this.renderFieldv2(this.fields.heating1PumpAddon)}
                                        </Row.Column3>
                                    )}

                                    {this.fields.heating2PumpAddon.visible && (
                                        <Row.Column3>
                                            <span
                                                className="configuration-editor-controller-heating-label heating-name-antioverflow">{this.props.model.heating2.name.value}</span>
                                            {this.renderFieldv2(this.fields.heating2PumpAddon)}
                                        </Row.Column3>
                                    )}

                                    {this.fields.heating3PumpAddon.visible && (
                                        <Row.Column3>
                                            <span
                                                className="configuration-editor-controller-heating-label heating-name-antioverflow">{this.props.model.heating3.name.value}</span>
                                            {this.renderFieldv2(this.fields.heating3PumpAddon)}
                                        </Row.Column3>
                                    )}

                                    {this.fields.dhwPumpAddon.visible && (
                                        <Row.Column3>
                                            <span
                                                className="configuration-editor-controller-heating-label heating-name-antioverflow">{this.props.model.dhw.name.value}</span>
                                            {this.renderFieldv2(this.fields.dhwPumpAddon)}
                                        </Row.Column3>
                                    )}
                                </Row.Container>
                            </StepHorizontalField>
                        </div>
                        {this.renderGenericHorizontalField(this.fields.additionalOptions, {}, [], undefined, 'additional-options')}
                    </React.Fragment> : <React.Fragment></React.Fragment>}

            </ExpandableContainer>
        )
    }

    static getFields(step) {
        const createField = name => new Field(name, step)

        return {
            commisioning: createField('commisioning'),
            iqHeatCloud: createField('iqHeatCloud'),
            pipeInsulation: createField('pipeInsulation'),
            additionalOptions: createField('additionalOptions'),
            heating1PumpAddon: new CrossReferencedHeatingField('pumpAddOn', step, 1),
            heating2PumpAddon: new CrossReferencedHeatingField('pumpAddOn', step, 2),
            heating3PumpAddon: new CrossReferencedHeatingField('pumpAddOn', step, 3),
            dhwPumpAddon: new CrossReferencedDHWField('pumpAddOn', step)
        }
    }

    static getStepModel(model) {
        return new StepModel('optionsAndAccessories', model.optionsAndAccessories)
    }
}